// Revival: predictive search for the header search bar(s), using Shopify's /search/suggest.json.
(function () {
  if (window.__rvSearch) return; window.__rvSearch = true;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(v) { var n = Number(v); if (isNaN(n)) return ''; try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(n); } catch (e) { return '$' + n.toFixed(2); } }

  function init(form) {
    var input = form.querySelector('.rv-search__input');
    var box = form.querySelector('.rv-search__results');
    var timer = null, ctrl = null, last = '';
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }

    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], collections = r.collections || [], queries = r.queries || [];
      var articles = r.articles || [], pages = r.pages || [];
      if (!products.length && !collections.length && !queries.length && !articles.length && !pages.length) {
        box.classList.add('rv-search__results--one'); box.innerHTML = '<p class="rv-search__empty">No matches yet. Press Enter to search the whole site.</p>'; open(); return;
      }
      var html = '<div class="rv-search__main">';
      if (queries.length) {
        html += '<ul class="rv-search__queries">' + queries.slice(0, 3).map(function (s) {
          return '<li><a href="' + esc(s.url) + '">' + (s.styled_text || esc(s.text)) + '</a></li>';
        }).join('') + '</ul>';
      }
      if (products.length) {
        html += '<p class="rv-search__label">Products</p><ul class="rv-search__products">' + products.slice(0, window.innerHeight < 760 ? 4 : 6).map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          return '<li><a href="' + esc(p.url) + '" data-handle="' + esc(p.handle) + '">' +
            (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" width="48" height="48" loading="lazy">' : '<span class="rv-search__ph"></span>') +
            '<span class="rv-search__pt">' + esc(p.title) + '</span>' +
            '<span class="rv-search__pp">' + esc(money(p.price)) + '</span></a></li>';
        }).join('') + '</ul>';
      }
      html += '</div><div class="rv-search__side">';
      var reads = articles.slice(0, 3).map(function (x) { return { url: x.url, title: x.title, tag: 'Article' }; })
        .concat(pages.slice(0, 2).map(function (x) { return { url: x.url, title: x.title, tag: 'Page' }; }));
      if (reads.length) {
        html += '<p class="rv-search__label">Learning Center and help</p><ul class="rv-search__reads">' + reads.map(function (x) {
          return '<li><a href="' + esc(x.url) + '"><span class="rv-search__rt">' + esc(x.title) + '</span><span class="rv-search__rtag">' + x.tag + '</span></a></li>';
        }).join('') + '</ul>';
      }
      if (collections.length) {
        html += '<p class="rv-search__label">Categories</p><ul class="rv-search__cols">' + collections.slice(0, 4).map(function (c) {
          return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>';
        }).join('') + '</ul>';
      }
      html += '</div>';
      html += '<a class="rv-search__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for “' + esc(q) + '”</a>';
      box.innerHTML = html;
      box.classList.toggle('rv-search__results--one', !reads.length && !collections.length);
      open();
      if (products.length && window.RevivalPriceGroup) groupPrices(q);
    }

    // Shelter and employee customers: swap in their price (rendered server-side, metafields aren't in suggest.json).
    function groupPrices(q) {
      fetch(root + 'search/suggest?q=' + encodeURIComponent(q) + '&section_id=revival-search-prices' +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var m = html.match(/data-rv-group-prices>([\s\S]*?)<\/script>/);
          var map = m ? JSON.parse(m[1]) : {};
          box.querySelectorAll('a[data-handle]').forEach(function (a) {
            var cents = map[a.dataset.handle];
            var el = a.querySelector('.rv-search__pp');
            if (cents && el) el.innerHTML = '<span class="rv-search__gp">' + esc(money(cents / 100)) + '</span> <s>' + el.textContent + '</s>';
          });
        }).catch(function () {});
    }

    function query(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag';
      fetch(url, { signal: ctrl.signal }).then(function (r) { return r.json(); }).then(function (d) { if (input.value.trim() === q) render(q, d); }).catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); last = ''; return; }
      if (q === last) return;
      timer = setTimeout(function () { last = q; query(q); }, 180);
    });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowDown' && links.length && !box.hidden) { e.preventDefault(); links[0].focus(); }
    });
    box.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (links[i + 1] || links[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else links[i - 1].focus(); }
      if (e.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  function boot() { document.querySelectorAll('[data-rv-search]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
